'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('settings-list', {
      url: '/admin/settings/list',
      template: '<settings-list></settings-list>',
        authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/settings-list/settings-list.routes.js